export default __webpack_public_path__ + "static/media/Natalie_9781408312797.fbf108ed.jpg";